import * as React from 'react';
import * as styles from './MobileLayout.css';
import { Section } from '../Section';

export interface IMobileLayoutProps {
  gallery: React.ReactNode;
  newbuildingInfo: React.ReactNode;
  loadMoreButton: React.ReactNode;
  banner: React.ReactNode;
  actionButton: React.ReactNode;
}

export const MobileLayout: React.FC<IMobileLayoutProps> = props => {
  const { newbuildingInfo, gallery, loadMoreButton, banner, actionButton } = props;

  return (
    <div className={styles['layout']} data-testid="MobileLayout">
      <Section className={styles['newbuildingInfo']} data-mark="jk_info_construction_progress">
        {newbuildingInfo}
      </Section>
      <Section className={styles['gallery']} data-mark="gallery_construction_progress">
        {gallery}
        {loadMoreButton}
      </Section>
      <div className={styles['banner']}>{banner}</div>
      <div className={styles['action-button']}>{actionButton}</div>
    </div>
  );
};
